export const algoliaAppId = process.env.REACT_APP_ALGOLIA_APP_ID
export const algoliaSearchKey = process.env.REACT_APP_ALGOLIA_SEARCH_KEY
export const algolia_api_key = process.env.REACT_APP_ALGOLIA_API_KEY
export const gatsby_index_name = process.env.REACT_APP_GATSBY_INDEX_NAME
export const google_tag = process.env.REACT_APP_GOOGLE_TAG || null
export const google_tag_manager = process.env.REACT_APP_GOOGLE_TAG_MANAGER || null
// We are integrating with Clarity via GOOGLE_TAG_MANAGER
// export const clarity_tag = process.env.REACT_APP_CLARITY_TAG || null

